import { getRandomTheme } from "../utils/themeUtils";

export const introductionPageStore = () => ({
    randomizedTheme: {},

    init() {
        this.randomizedTheme = getRandomTheme();
    }
});
